// Module
var code = `<p class="p-{{classVal}}">{{heading}}</p>
`;
// Exports
module.exports = code;